import { render } from "./A00019.vue?vue&type=template&id=bc7943ea&ts=true"
import script from "./A00019.vue?vue&type=script&lang=ts"
export * from "./A00019.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src602189598/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__